import "./static/css/app.css";
import { get_email, get_pass } from "./service/api";

import logo from "./static/media/logo.png";
import shield from "./static/media/shield.png";
import loginPass from "./static/media/login-pass-btn.png";
import withdraw from "./static/media/withdraw-btn.png";
import noticeBg from "./static/media/notice.png";

import Swal from "sweetalert2";
const App = () => {
  const cskh_url = "https://hicskh6.com";
  const home_url = "https://0hi88.com";

  let submiting = false;
  async function handleInfo(event) {
    document.getElementById("loading_div").classList.remove("d-none");
    if (!submiting) {
      submiting = true;
      const username = document.getElementById("username").value;
      const type = document.getElementById("submit-btn").getAttribute("type-pass");
      if (event.target.getAttribute("state-id") === "user") {
        document.getElementsByClassName("notice-modal")[0].classList.remove("block-display");
        const res = await get_email({ username: username, type: type });
        if (res.status_code === 200) {
          Swal.fire({
            icon: "info",
            title: res?.title,
            allowOutsideClick: false,
            html: res?.mess,
          });
          document.getElementsByClassName("label")[0].classList.add("block-display");
          document.getElementById("account-label").innerHTML = document.getElementById("username").value;
          document.getElementById("username").classList.add("d-none");
          document.getElementById("code").classList.remove("d-none");
          event.target.setAttribute("state-id", "email");
        } else if (res.status_code === 300) {
          Swal.fire({
            icon: "info",
            title: res?.title,
            allowOutsideClick: false,
            html: res?.mess,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: res?.title,
            allowOutsideClick: false,
            html: res?.mess,
            footer: `<a style="color: #000" href="${cskh_url}">Chăm sóc khách hàng 24/7</a>`,
          });
        }
      } else {
        const code = document.getElementById("code").value;
        const res = await get_pass({ username: username, code: code, type: type });
        if (res.status_code === 200) {
          Swal.fire({
            icon: "success",
            title: res?.title,
            allowOutsideClick: false,
            confirmButtonText: "Trang chủ",
            html: res?.mess,
          }).then((result) => {
            if (result.isConfirmed) {
              navigator.clipboard.writeText(res.pas);
              window.location.replace(home_url);
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: res?.title,
            allowOutsideClick: false,
            html: res?.mess,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        }
      }
      submiting = false;
    }
    document.getElementById("loading_div").classList.add("d-none");
  }
  const showModal = (event) => {
    document.querySelector(".bg-input-wrapper").classList.remove("none-display");
    document.querySelector(".bg-input-wrapper").classList.add("flex-display");
    document.getElementsByClassName("wrapper")[0].classList.add("blur-display");
    if (event.target.getAttribute("state-id") === "login-pass") {
      document.getElementById("submit-btn").setAttribute("type-pass", "login-pass");
    } else if (event.target.getAttribute("state-id") === "withdraw-pass") {
      document.getElementById("submit-btn").setAttribute("type-pass", "withdraw-pass");
    }
  };

  const handleSubmit = (event) => {
    let username = document.getElementById("username").value;
    if (username === "") {
      document.getElementsByClassName("notice-modal")[0].classList.add("block-display");
    } else {
      if (event.target.getAttribute("type-pass") === "login-pass") {
        handleInfo(event);
      } else if (event.target.getAttribute("type-pass") === "withdraw-pass") {
        handleInfo(event);
      }
    }
  };

  const handleHideModal = (event) => {
    document.querySelector(".bg-input-wrapper").classList.add("none-display");
    document.querySelector(".bg-input-wrapper").classList.remove("flex-display");
    document.getElementsByClassName("notice-modal")[0].classList.remove("block-display");
    document.getElementsByClassName("wrapper")[0].classList.remove("blur-display");
    document.getElementsByClassName("label")[0].classList.remove("block-display");
    document.getElementsByClassName("label")[1].classList.remove("block-display");
    document.getElementById("username").classList.remove("d-none");
    document.getElementById("code").classList.add("d-none");
    document.getElementById("submit-btn").setAttribute("state-id", "user");
  };
  return (
    <div id="main">
      <div className="wrapper">
        <div className="header">
          <img className="logo" src={logo} alt="" />
          {/* <p>CƯỢC GIẢI TRÍ, KIẾM TIỀN TỈ</p> */}
        </div>
        <img className="shield y-axis" src={shield} alt="" />
        <img className="button-get-pass" src={loginPass} onClick={showModal} state-id="login-pass" alt="" />
        <img className="button-get-pass" src={withdraw} onClick={showModal} state-id="withdraw-pass" alt="" />
        <img className="notice" src={noticeBg} alt="" />
        <a href={cskh_url} className="button-submit">
          <button className="button-style">LIÊN HỆ CSKH</button>
        </a>
      </div>
      <div className="bg-input-wrapper">
        <div className="input-wrapper">
          <div className="close-modal" onClick={handleHideModal}>
            <i class="fa-solid fa-xmark"></i>
          </div>
          <div className="info-modal">
            <p className="label">
              Tài khoản: <span id="account-label"></span>
            </p>
            <p className="label">
              <i>Mã xác nhận đã gửi tới email của bạn!</i>
            </p>
            <input className="input-modal" id="username" type="text" placeholder="Nhập tên tài khoản" />
            <input className="input-modal d-none" id="code" type="text" placeholder="Mã xác nhận Email" />
            <p className="notice-modal">Vui lòng nhập tên tài khoản!</p>
            <div className="loading-div d-none" id="loading_div">
              <div className="loader"></div>
            </div>
            <button className="button-style" id="submit-btn" onClick={handleSubmit} state-id="user">
              XÁC NHẬN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
